import { render } from "./Navframe.vue?vue&type=template&id=dd910800&scoped=true"
import script from "./Navframe.vue?vue&type=script&lang=js"
export * from "./Navframe.vue?vue&type=script&lang=js"

import "./Navframe.vue?vue&type=style&index=0&id=dd910800&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd910800"]])

export default __exports__